import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import ObesityPatientForm from "../components/ObesityPatientForm";
import {
  FaUserPlus,
  FaUserCheck,
  FaDownload,
  FaSearch,
  FaCalendarAlt,
  FaFileAlt,
  FaStopwatch,
  FaFlask,
  FaHistory,
} from "react-icons/fa";
import PatientTypeSelector from "../components/PatientTypeSelector";

function ObeseForm({ name }) {
  const [id, setId] = useState("");
  const [patientname, setName] = useState("");
  const [age, setAge] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [sleepDuration, setSleepDuration] = useState("");
  const [gender, setGender] = useState("");
  const [familyHistory, setFamilyHistory] = useState("");
  const [tshLevel, setTshLevel] = useState("");
  const [obeseLevel, setObeseLevel] = useState("");
  const [positiveWords, setPositiveWords] = useState([]);
  const [bmi, setBmi] = useState("");
  const [dateOfVisit, setDateOfVisit] = useState("");
  const [patientType, setPatientType] = useState("new");
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false); // State variable for showing success message
  const [oldbmi, setOldBmi] = useState(bmi); // Define old bmi state
  const [oldDateOfVisit, setOldDateOfVisit] = useState(dateOfVisit); // Define oldDateOfVisit state
  const [oldTshLevel, setOldTshLevel] = useState(tshLevel); // Define old tshLevel state
  const [oldSleepDuration, setOldSleepDuration] = useState(sleepDuration); // Define old sleepDuration state
  const [oldWeight, setOldWeight] = useState(weight); // Define old weight state
  const [transcript, setTranscript] = useState("");
  const [duration, setDuration] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [graphImage, setGraphImage] = useState("");
  const [showPreviousMeasurements, setShowPreviousMeasurements] = useState(false);
  const endOfScreenRef = useRef(null);
  const navigate = useNavigate();

  const highlightPositiveWords = (text) => {
    if (!text) return text;
    return text.split(" ").map((word, index) => {
      const wordLowerCase = word.toLowerCase();
      const isPositive = positiveWords.includes(wordLowerCase);

      return isPositive ? (
        <span key={index} className="highlight">
          {word}{" "}
        </span>
      ) : (
        <span key={index}>{word} </span>
      );
    });
  };
  const fetchPatientById = async (id) => {
    try {
      const response = await axios.get(
        `https://4.240.97.130:8443/api/obese/get_patient_data/${id}`
      );
      const transcriptResponse = await axios.get(
        `https://4.240.97.130:8443/api/obese/get_transcription/${id}`
      );
      const patientData = response.data;
      const transcriptData = transcriptResponse.data;
      console.log("Patient transcriptData:", transcriptData);
      if (!patientData || Object.keys(patientData).length === 0) {
        // If patientData is empty, show an error message
        setId("");
        setName("");
        setAge("");
        setHeight("");
        setWeight("");
        setSleepDuration("");
        setGender("");
        setFamilyHistory("");
        setTshLevel("");
        setObeseLevel("");
        setTranscript("");
        setOldBmi("");
        setOldTshLevel("");
        setOldSleepDuration("");
        setOldWeight("");
        setDuration("");
        setDateOfVisit("");
        
        setShowErrorMessage(true);
        return;
      }
      setId(patientData.patient_id);
      setName(patientData.patient_name);
      setAge(patientData.age);
      setHeight(patientData.height);
      setWeight(patientData.weight);
      setSleepDuration(patientData.sleep_duration);
      setGender(patientData.gender);
      setFamilyHistory(patientData.family_history);
      setTshLevel(patientData.tsh_level);
      setObeseLevel(patientData.obese_level);
      setDateOfVisit(patientData.date_of_visit);
      setTranscript(transcriptData.transcription);
      setDuration(transcriptData.duration);
      setGraphImage(patientData.show_graph_image);

      if (endOfScreenRef.current) {
        endOfScreenRef.current.scrollIntoView({ behavior: "smooth" });
      }
      // let lastVisitDataFPG = null;
      // let lastVisitDataPPG = null;
      // let lastVisitDataHbA1c = null;

      // lastVisitDataFPG = patientData.fpg;
      // lastVisitDataPPG = patientData.ppg;
      // lastVisitDataHbA1c = patientData.hba1c;


      if (patientData.visit_history && patientData.visit_history.length < 2) {
        console.log("Not enough visits, showing previous measurements"); // Debug log
        setShowPreviousMeasurements(true);
        setOldBmi(patientData.visit_history[0]?.bmi || '');
        setOldTshLevel(patientData.visit_history[0]?.tsh_level || '');
        setOldSleepDuration(patientData.visit_history[0]?.sleep_duration || '');
        setOldWeight(patientData.visit_history[0]?.weight || '');
        setOldDateOfVisit(patientData.visit_history[0]?.date_of_visit || '');

      } else {
        console.log("Enough visits, showing comparison image"); // Debug log
        setShowPreviousMeasurements(false);
        setGraphImage(patientData.show_graph_image);
    
      }

      console.log("showPreviousMeasurements:", showPreviousMeasurements); // Debug log
      console.log("graphImage:", patientData.show_graph_image); // Debug log
      setShowErrorMessage(false); // Reset the error message
    } catch (error) {
      console.error("Error fetching patient data:", error);
      setShowErrorMessage(true); // Set the error message to true
    }
  };
  const updateGraph = async (newBmi, newTshLevel, newSleepDuration, newWeight) => {
    try {
      const formData = new FormData();
  
      // Only append values that are not empty
      if (newBmi !== "") formData.append("new_bmi", newBmi);
      if (newTshLevel !== "") formData.append("new_tsh_level", newTshLevel);
      if (newSleepDuration !== "") formData.append("new_sleep_duration", newSleepDuration);
      if (newWeight !== "") formData.append("new_weight", newWeight);
  
      // Only make the API call if at least one value is present
      if (formData.has("new_bmi") || formData.has("new_tsh_level") || 
          formData.has("new_sleep_duration") || formData.has("new_weight")) {
        const response = await axios.post(
          `https://4.240.97.130:8443/api/obese/compare_patient_data/${id}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        setGraphImage(response.data.comparison_image);
      }
    } catch (error) {
      console.error("Error updating graph:", error);
    }
  };

  const handleWeightChange = (e) => {
    const newWeight = e.target.value;
    setWeight(newWeight);
    updateGraph(bmi, tshLevel, sleepDuration, newWeight);
  };

  const handleTshChange = (e) => {
    const newTsh = e.target.value;
    setTshLevel(newTsh);
    updateGraph(bmi, newTsh, sleepDuration, weight);
  };

const handleBmiChange = (e) => {
  const newBmi = e.target.value;
  setBmi(newBmi);
  updateGraph(newBmi, tshLevel, sleepDuration, weight);
};

  const handleSleepDurationChange = (e) => {
    const newSleepDuration = e.target.value;
    setSleepDuration(newSleepDuration);
    updateGraph(bmi, tshLevel, newSleepDuration, weight);
  };

  const handleSearch = (e) => {
    const inputValue = e.target.value;
    setId(inputValue);
    if (inputValue.trim() !== "") {
      fetchPatientById(inputValue);
    }
  };
  useEffect(() => {
    if (height > 0 && weight > 0) {
      const bmiValue = (weight / (height / 100) ** 2).toFixed(2);
      setBmi(bmiValue);
    } else {
      setBmi("");
    }
  }, [height, weight]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
    if (patientType === "recurring") {
      // Save the updated data first
      await axios.post(
        `https://4.240.97.130:8443/api/obese/save_patient_data`,
        {
          id: id,
          patientname: patientname,
          age: age,
          height: height,
          weight: weight,
          bmi: bmi,
          sleep_duration: sleepDuration,
          gender: gender,
          family_history: familyHistory,
          tsh_level: tshLevel,
          obese_level: obeseLevel,
          date_of_visit: dateOfVisit, // Format the date
        }
      );

      // Then fetch the updated patient data

      await fetchPatientById(id);
    } else {
      // For new patients, save the data as before
      await axios.post(
        `https://4.240.97.130:8443/api/obese/save_patient_data`,
        {
          id: id,
          patientname: patientname,
          age: age,
          height: height,
          weight: weight,
          bmi: bmi,
          sleep_duration: sleepDuration,
          gender: gender,
          family_history: familyHistory,
          tsh_level: tshLevel,
          obese_level: obeseLevel,
          date_of_visit: dateOfVisit, // Format the date
        }
      );
    }


        setIsLoading(false);
        navigate("/obesewordcloud", {
          state: {
            age: age,
            height: height,
            weight: weight,
            bmi: bmi,
            sleep_duration: sleepDuration,
            gender: gender,
            family_history: familyHistory,
            tsh_level: tshLevel,
            obese_level: obeseLevel,
            patientId: id, // Pass patientId to the WordCloud component
          },
        }); // Redirect to the WordCloud component
      } catch (error) {
        setIsLoading(false);
        console.error("Error saving patient data:", error);
      }
    }



  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];

    if (patientType === "recurring" && id) {
      // If it's a recurring patient and an ID is provided, set dateOfVisit to today's date
      setDateOfVisit(currentDate);
    } else if (patientType === "new") {
      // If it's a new patient, set dateOfVisit to today's date
      setDateOfVisit(currentDate);
    }
  }, [patientType, id]);
  const downloadAllPatients = async () => {
    try {
      const response = await axios.get(
        `https://4.240.97.130:8443/api/obese/download_all_patients`,
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "all_patients.csv");

      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading all patients:", error);
    }
  };

  useEffect(() => {
    // Clear the stored word cloud data from localStorage when the component unmounts
    return () => {
      localStorage.removeItem("wordCloudData");
    };
  }, [navigate]);

  return (
    <div className="flex flex-col min-h-screen ">
        <div className="flex-1 z-10">
        <Navbar name={name} />
        </div>      
        <div className="relative isolate px-6  lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div className="mx-auto max-w-5xl">
          <div className="text-center">
            <div className="flex-grow container mx-auto px-4 py-8 flex flex-col items-center justify-center ">
              {" "}
              <div className="w-full max-w-5xl rounded-lg shadow-2xl overflow-hidden mt-6">
                <div className="p-4 sm:p-8 space-y-6 sm:space-y-8  ">
                  <h1 className="text-4xl font-bold text-center text-orange-500">
                    Patient Information
                  </h1>

                  <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0 sm:space-x-4">
                    <PatientTypeSelector
                        patientType={patientType}
                        setPatientType={setPatientType}
                      />
                    <button
                      className="w-full sm:w-auto px-4 py-2 bg-green-500 text-white rounded-full hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors duration-300 flex items-center justify-center"
                      onClick={downloadAllPatients}
                    >
                      <FaDownload className="mr-2" />
                      Download All
                    </button>
                  </div>

                  {showSuccessMessage && (
                    <div
                      className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded"
                      role="alert"
                    >
                      <p className="font-bold">Success!</p>
                      <p>Patient data saved successfully.</p>
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className="space-y-6">
                    {patientType === "recurring" ? (
                      <div className="rounded-lg p-8 space-y-8">
                        <div>
                          <label
                            htmlFor="search-patient-id"
                            className="block text-lg font-semibold text-blue-800 mb-2"
                          >
                            Search Patient by ID
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              id="search-patient-id"
                              name="searchPatientId"
                              className="w-full pl-12 pr-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                              placeholder="Enter Patient ID"
                              value={id}
                              onInput={handleSearch}
                            />
                            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" />
                          </div>
                        </div>
                        {showErrorMessage && (
                          <div
                            className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-lg"
                            role="alert"
                          >
                            <p className="font-bold">Error</p>
                            <p>No patient details found for the provided ID.</p>
                          </div>
                        )}
                        {id && !showErrorMessage && (
                          <div className="space-y-8">
                            <h2 className="text-3xl font-bold text-center text-blue-800 mb-6">
                              Patient Details
                            </h2>

                            <div className="grid grid-cols-1 gap-4">
                              {/* Patient ID */}
                              <div className="hidden">
                                <label className="block text-gray-700 font-bold mb-2">
                                  Patient ID
                                </label>
                                <input
                                  type="text"
                                  id="patientid"
                                  name="id"
                                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                  value={id}
                                  onChange={(e) => e.preventDefault()}
                                  readOnly
                                  disabled
                                />
                              </div>
                              {/* Patient Name */}
                              <div className="hidden">
                                <label className="block text-gray-700 font-bold mb-2">
                                  Patient Name
                                </label>
                                <input
                                  type="text"
                                  id="patientname"
                                  name="patientname"
                                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                  value={patientname}
                                  onChange={(e) => setName(e.target.value)}
                                />
                              </div>
                              {/* Age */}
                              <div className="hidden">
                                <label className="block text-gray-700 font-bold mb-2">
                                  Age
                                </label>
                                <input
                                  type="text"
                                  id="age"
                                  name="age"
                                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                  value={age}
                                  onChange={(e) => setAge(e.target.value)}
                                />
                              </div>
                              {/* Cultural Background */}
                              <div className="hidden">
                                <label
                                  htmlFor="height"
                                  className="block text-gray-700 font-bold mb-2"
                                >
                                  Height
                                </label>
                                <input
                                  type="number"
                                  id="height"
                                  name="height"
                                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                                  value={height}
                                  onChange={(e) => setHeight(e.target.value)}
                                />
                              </div>
                    

                              <div className="bg-gray-50 p-6 rounded-lg shadow-inner">
                                <label className=" text-gray-700 font-semibold mb-3 flex items-center">
                                  <FaFileAlt className="mr-2 text-blue-600" />
                                  Last Visit Recap
                                </label>
                                <p className="text-sm text-gray-500 mb-2 flex items-center">
                                  <FaStopwatch className="mr-2 text-blue-600" />
                                  Duration: {duration} seconds
                                </p>
                                <div className="w-full text-left px-4 py-3 bg-white rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 resize-none">
                                  {highlightPositiveWords(transcript)}
                                </div>
                              </div>
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <FormField
                                  icon={<FaCalendarAlt />}
                                  label="Date of Visit"
                                  type="date"
                                  id="dateofvisit"
                                  value={dateOfVisit}
                                  readOnly
                                />
                                <FormField
                                                                  label="Obese Level"
                                                                  type="select"
                                                                  id="obese-level"
                                                                  value={obeseLevel}
                                                                  onChange={(e) => setObeseLevel(e.target.value)}
                                                                >
                                                                  <option value="">Select Obese Level</option>
                                                                  <option value="Under_Weight">UnderWeight</option>
                                                                  <option value="Normal_Weight">Over Normal Weight</option>
                                                                  <option value="Over_Weight">Over Weight</option>
                                                                  <option value="Obese">Obese</option>
                                                                  <option value="Morbid_Obesity">Morbid Obesity</option>

                             
                                                                </FormField>  
                              </div>

                              {graphImage ? (
  <div className="p-6 rounded-lg shadow-inner">
    <img
      src={`data:image/png;base64,${graphImage}`}
      alt="comparison"
      className="w-full"
    />
  </div>
) : (
  <div>No comparison data available</div>
)}

                              <div
                                ref={endOfScreenRef}
                                className="bg-green-100 p-6 rounded-lg shadow-inner"
                              >
                                <h3 className="text-xl font-semibold mb-4 text-green-800">
                                  New Measurements
                                </h3>
                                <div className="grid grid-cols-4 gap-6">
                                  <FormField
                                    icon={<FaFlask />}
                                    label="weight"
                                    type="number"
                                    id="weight"
                                    onChange={handleWeightChange}
                                    placeholder="weight"
                                    required
                                  />

                                  <FormField
                                    label="BMI"
                                    type="number"
                                    id="bmi"
                                    value={bmi}
                                    onChange={handleBmiChange}
                                    placeholder="BMI"
                                    readOnly
                                  />
                                  <FormField
                                    icon={<FaFlask />}
                                    label="TSH Level"
                                    type="text"
                                    id="tsh"
                                    onChange={handleTshChange}
                                    placeholder="TSH"
                                    required
                                  />

                                  <FormField
                                        icon={<FaHistory />}
                                        label="Sleep Duration"
                                        type="number"
                                        id="sleepduration"
                                        value={sleepDuration}
                                        onChange={handleSleepDurationChange}
                                        placeholder="Sleep Duration"
                                        required
                                      />

                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <ObesityPatientForm
                        id={id}
                        setId={setId}
                        patientname={patientname}
                        setName={setName}
                        age={age}
                        setAge={setAge}
                        height={height}
                        setHeight={setHeight}
                        weight={weight}
                        setWeight={setWeight}
                        bmi={bmi}
                        setBmi={setBmi}
                        sleepDuration={sleepDuration}
                        setSleepDuration={setSleepDuration}
                        gender={gender}
                        setGender={setGender}
                        familyHistory={familyHistory}
                        setFamilyHistory={setFamilyHistory}
                        tshLevel={tshLevel}
                        setTshLevel={setTshLevel}
 
                        obeseLevel={obeseLevel}
                        setObeseLevel={setObeseLevel}
                        dateOfVisit={dateOfVisit}
                        setDateOfVisit={setDateOfVisit}
                      />
                    )}

                    <div className="flex justify-center">
                      <button
                        type="submit"
                        className="px-8 py-3 bg-custom-gradient text-white font-semibold rounded-full  transition-colors duration-300 transform hover:scale-105"
                        disabled={isLoading}
                      >
                        {isLoading
                          ? "Loading..."
                          : "Generate Conversation Cues"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>{" "}
          </div>
        </div>
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-50rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
      </div>
    </div>
  );
}
const FormField = ({
  icon,
  label,
  type,
  id,
  value,
  onChange,
  placeholder,
  children,
  readOnly,
  required,
}) => {
  return (
    <div>
      <label
        htmlFor={id}
        className="text-sm font-medium text-gray-700 mb-2 flex items-center"
      >
        {icon && <span className="mr-2 text-blue-600">{icon}</span>}
        {label}
      </label>
      {type === "select" ? (
        <select
          id={id}
          className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
          value={value}
          onChange={onChange}
        >
          {children}
        </select>
      ) : (
        <input
          type={type}
          id={id}
          className={`w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 ${readOnly ? "bg-white-100" : ""}`}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          required={required}
        />
      )}
    </div>
  );
};
export default ObeseForm;
